import React, { useEffect, useState } from 'react';
import '../../CSS/Proyectos.css'
import { useNavigate } from 'react-router';
import { getPermission} from "../../Conexiones/Conexion";
import { BsPlus } from "react-icons/bs";
import CardProyecto from './CardProyecto';
import CarObra from '../AdministracionObras/CarObra';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { getApi, postApiImg } from '../../Conexiones/Models';
import { errorMessage, errorToast, successToast, warningToast } from '../../Utils/AlertMessage';
import { Button, CloseButton, Modal } from 'react-bootstrap';
import Select from 'react-select';
import Loading from '../../Utils/Loading';

function Proyectos() {
    const [proyectos, setProyectos] = useState([]);
    const navigate = useNavigate()
    const [obras, setObras] = useState([]);
    const usuario = JSON.parse(sessionStorage.getItem('user')) 
    const idUsuario = usuario[0].idUsuario
    const uri = 'proyectos-obras/';
    const [isLoading,setIsLoading]=useState(false);

    useEffect(() => {
        const getProyectos = async () => {
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,17);
            if(permiso){
                const endpoint = uri;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setProyectos(res.data[0].proyectos);
                        setObras(res.data[0].obras);
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio')
            }
            setIsLoading(false);
        };
        getProyectos();
    },[navigate,idUsuario]);

    const getProyectos = async () => {
        const endpoint = uri;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setProyectos(res.data[0].proyectos);
                setObras(res.data[0].obras);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    };

    const regresar = () => {
        navigate('/inicio')
    }

    const getTipos = async () =>{
        const endpoint = 'tiposObra/';
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setObrasTipos(res.data);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }

    const [nomProyecto, setNombreProyec] = useState("");
    const [img, setImg] = useState(null);
    const [seleccionado, setSeleccionado] = useState("");

    const [nombreObra,setNombreObra]=useState('')
    const [direcObra,setdirecObra]=useState('')
    const [cliente,setCliente]=useState('')
    const [fechaInicio,setFechaI]=useState('')
    const [fechaFinal,setFechaF]=useState('')
    const [tipo,setTipo]=useState('')
    //const [nombreTipo,setNombreTipo]=useState('')
    //const [idEmpleado,setEmp]=useState('')
    const [imgO,setImgO]=useState(null)
    const [obrasTipos,setObrasTipos]=useState([])
    //const [empleados,setEmpleados]=useState([])
    const [pisos,setPisos]=useState('')
    const [isSaving, setSaving] = useState(false);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleCloseAdd = () => {
        handleClose();
        setSeleccionado('');
        setNombreProyec('');
        setImg(null);
        setNombreObra('');
        setdirecObra('');
        setCliente('');
        setFechaI('');
        setFechaF('');
        setTipo('');
        setImgO(null);
        setPisos('');
    }
    const handleShowAdd = async () => {
        await getTipos();
        handleShow();
    }
    const options = [
        { value: 'obra', label: 'Obra' },
        { value: 'proyecto', label: 'Proyecto' },
    ]
    const handleSelectChange = (event) =>{
        setSeleccionado(event.value)
    }
    const handleSelecTipo = (event) =>{
        setTipo(event.value)
    }
    const addProyecto = async (e) => {
        setSaving(true);
        e.preventDefault();
        if(nomProyecto.trim().length === 0){
            warningToast('CAMPOS VACIOS');
        }else{
            const formdata = new FormData();
            formdata.append("image", img);
            formdata.append("name", nomProyecto);
            const endpoint = 'proyectos/';
            const res = await postApiImg(endpoint,formdata);
            if(res.status === 1){
                if(res.data.message==="¡Registro creado correctamente!"){
                    handleCloseAdd();
                    getProyectos();
                    successToast("AGREGADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
        setSaving(false);
    };

    const createObra = async (e) =>{
        setSaving(true);
        e.preventDefault()
        if(nombreObra.trim().length === 0 | direcObra.trim().length === 0 | cliente.trim().length === 0 | tipo === ''){
            warningToast('CAMPOS VACIOS');
        }else{
            const idTipo= parseInt(tipo)
            //const idEmp= parseInt(idEmpleado)
            const formdata = new FormData();
            formdata.append("image", imgO);
            formdata.append("name", nombreObra);
            formdata.append("direccion", direcObra);
            formdata.append("cliente", cliente);
            formdata.append("fechaI", fechaInicio);
            formdata.append("fechaF", fechaFinal);
            formdata.append("tipo", idTipo);
            formdata.append("pisos", pisos);
            //formdata.append("idAdministrador",idEmp);
            const endpoint = 'obras/';
            const res = await postApiImg(endpoint,formdata);
            if(res.status === 1){
                if(res.data.message==="¡Registro creado correctamente!"){
                    handleCloseAdd();
                    getProyectos();
                    successToast("AGREGADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
        setSaving(false);
    }

    return (
        <div className="proyectos-container">
            {
                isLoading ? 
                <Loading />:
                <div>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label className="text-uppercase">GESTIÓN DE PROYECTOS Y OBRAS</label>
                    </div>
                    <div className='proyectos-subheader'>
                        {
                            idUsuario === 185 ?
                            null :
                            <div className='boton' >
                                <button  className="btn btncolor" onClick={handleShowAdd} type="button">
                                <label className="agregar">AGREGAR</label><BsPlus style={{fontSize:'25px'}}/>    
                                </button>                                
                            </div>
                        }
                        
                    </div>
                    <div className="proyectos-body">
                        <div className="row">
                            <div className="col-sm col-md">
                                <div>
                                    <h3 className="tituloGastos"> PROYECTOS</h3>
                                </div>
                                <div className="rows-container">
                                    {
                                        proyectos.length === 0 ? (<h3 style={{marginTop:'30vh'}}>AUN NO HAY REGISTROS</h3>):(
                                            <div className="row ">
                                                {   //Restablecer
                                                    idUsuario === 185 ?
                                                    proyectos.map((elemento) => 
                                                        elemento.idProyecto === 2 ?
                                                        <div className="col-sm-6 mb-3 mb-sm-0  " key={elemento.idProyecto}>
                                                            <CardProyecto titulo={elemento.nombreProyecto}
                                                                imagen={elemento.imagenProyecto}
                                                                direccion={"Lista-Obras"}
                                                                id={elemento.idProyecto}
                                                            />
                                                        </div>:
                                                        null
                                                    ) : 
                                                    proyectos.map((elemento) => 
                                                        <div className="col-sm-6 mb-3 mb-sm-0  " key={elemento.idProyecto}>
                                                        <CardProyecto titulo={elemento.nombreProyecto}
                                                            imagen={elemento.imagenProyecto}
                                                            direccion={"Lista-Obras"}
                                                            id={elemento.idProyecto}
                                                        />
                                                        </div>
                                                    )
                                                }
                                                {/* proyectos.map((elemento) => 
                                                    <div className="col-sm-6 mb-3 mb-sm-0  " key={elemento.idProyecto}>
                                                    <CardProyecto titulo={elemento.nombreProyecto}
                                                        imagen={elemento.imagenProyecto}
                                                        direccion={"Lista-Obras"}
                                                        id={elemento.idProyecto}
                                                    />
                                                    </div>
                                                ) */}
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                            <div className="col-sm col-md">
                                <div>
                                    <h3 className="tituloGastos"> OBRAS</h3>
                                </div>
                                <div className="rows-container">
                                    {
                                        obras.length === 0 ? (<h3 style={{marginTop:'30vh'}}>AUN NO HAY REGISTROS</h3>):(
                                            <div className="row " >
                                                {
                                                    idUsuario === 185 ? 
                                                    null :
                                                    obras.map(obras =>{
                                                        return(
                                                            obras.proyecto===null ?(                       
                                                            <div className="col-sm-6 mb-3 mb-sm-0 " key={obras.idObra} >
                                                                <CarObra  titulo={obras.nombreObra} id={obras.idObra}
                                                                imagen={obras.imagenObra} direccion={"Administracion-Obras"} />
                                                            </div>
                                                            ):(null)
                                                        )
                                                    })
                                                }
                                                {/* obras.map(obras =>{
                                                    return(
                                                        obras.proyecto===null ?(                       
                                                        <div className="col-sm-6 mb-3 mb-sm-0 " key={obras.idObra} >
                                                            <CarObra  titulo={obras.nombreObra} id={obras.idObra}
                                                            imagen={obras.imagenObra} direccion={"Administracion-Obras"} />
                                                        </div>
                                                        ):(null)
                                                    )           
                                                }) */}
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    {/*AGREGAR PROYECTO/OBRA*/}
                    <Modal show={show} onHide={handleClose}  id="modal-agregar-obraProyecto" >
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>AGREGAR OBRA/PROYECTO</Modal.Title>
                            <CloseButton onClick={handleCloseAdd} style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <Modal.Body  style={{textAlign:'left', }}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <label htmlFor="exampleFormControlInput1" className="form-label">
                                SELECCIONAR
                                <label title="OBLIGATORIO" className="obligatorio">*</label>
                            </label>
                            <div className="mb-3">
                                <Select options={options} onChange={handleSelectChange} placeholder="Selecciona una opción..."/>
                            </div>
                            <div className="mb-3">
                                {seleccionado ==='proyecto'?(
                                    <div style={{overflowY:"scroll",height:"40vh"}}>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">PROYECTO
                                        <label title="OBLIGATORIO" className="obligatorio">*</label> </label>
                                        <input type="text" className="form-control" required value={nomProyecto}
                                        onChange={(e) => setNombreProyec(e.target.value)} aria-describedby="basic-addon1"/>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">IMAGEN
                                        <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                        <input type="file" required className="form-control" id="exampleFormControlInput1"
                                        onChange={(e) => setImg(e.target.files[0])} />
                                        <div className=" mb-3">
                                            <div style={{textAlign:"center", padding:'10px'}}>
                                                <img src={img === null ? null:URL.createObjectURL(img)} width={'50%'} alt={nomProyecto}/>
                                            </div>
                                        </div>
                                    </div >
                                ):(
                                    seleccionado === 'obra'?(
                                        <div style={{overflowY:"scroll",height:"40vh"}}>
                                            <label htmlFor="exampleFormControlInput1" className="text-uppercase" >Nombre de la obra <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                            <input type="text" required className="form-control" value={nombreObra} onChange={(e)=>setNombreObra(e.target.value)}    aria-describedby="basic-addon1"/>
                                            <label htmlFor="exampleFormControlInput1" className="text-uppercase" > dirección <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                            <input type="text" className="form-control" required
                                            value={direcObra} onChange={(e)=>setdirecObra(e.target.value)}    aria-describedby="basic-addon1"/>
                                            <label htmlFor="exampleFormControlInput1" className="text-uppercase" > cliente <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                            <input type="text" className="form-control" required  value={cliente} onChange={(e)=>setCliente(e.target.value)}   aria-describedby="basic-addon1"/>
                                            <label htmlFor="exampleFormControlInput1" className="text-uppercase" > Fecha de inicio <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                            <input type="date" className="form-control" required value={fechaInicio} onChange={(e)=>setFechaI(e.target.value)}    aria-describedby="basic-addon1"/>
                                            <label htmlFor="exampleFormControlInput1" className="text-uppercase" > fecha final <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                            <input type="date" className="form-control" required value={fechaFinal} onChange={(e)=>setFechaF(e.target.value)}    aria-describedby="basic-addon1"/>
                                            <label htmlFor="exampleFormControlInput1" className="text-uppercase"  > tipo de obra <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                            <Select
                                                classNamePrefix="select"
                                                placeholder="Selecciona un tipo de obra..."
                                                defaultValue={obrasTipos[0]}
                                                required
                                                options={obrasTipos.map(tip=>({label:tip.nombreTipoObra,value:tip.idTipoObra}))}
                                                onChange={handleSelecTipo}
                                            />
                                            <label htmlFor="exampleFormControlInput1" className="text-uppercase" > PISOS <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                            <input type="number" className="form-control" required
                                            value={pisos} min={0} onChange={(e)=>setPisos(e.target.value)}  aria-describedby="basic-addon1"/>
                                            <label htmlFor="exampleFormControlInput1" className="text-uppercase" > imagen <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                            <input type="file" required className="form-control" id="exampleFormControlInput1"
                                            onChange={(e) => setImgO(e.target.files[0])}/>
                                            <div className=" mb-3">
                                                <div style={{textAlign:"center", padding:'10px'}}>
                                                    <img src={imgO === null ? null:URL.createObjectURL(imgO)} width={'50%'} alt={nombreObra}/>
                                                </div>
                                            </div>
                                        </div>
                                    ):(null)
                                )}
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button type="button" className="btn btn-secondary" onClick={handleCloseAdd}>CANCELAR</Button>                                               
                                { isSaving===true? 
                                    <Button className="btn btn-primary" type="button" disabled >
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </Button>:
                                    seleccionado === 'proyecto' ? (
                                        <Button type="button" className="btn btn-light btncolor" onClick={addProyecto}  >GUARDAR CAMBIOS</Button> 
                                    ):(
                                        seleccionado==="obra"?
                                        ( <Button type="button" className="btn btn-light btncolor" onClick={createObra} >GUARDAR CAMBIOS</Button>
                                        ):(null)
                                    )
                                }
                        </Modal.Footer>
                    </Modal>
                </div>
            }
        </div>
    );
}

export default Proyectos;